import { SyntheticEvent, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import Toast from 'components/atoms/Toast'
import Input from 'components/atoms/Input'

interface IProps {
  show?: boolean
  onClose: () => void
  markOrderAsBilled: (reason: string) => Promise<unknown>
  title?: string
  description?: string
  successLabel?: string
}

export const MarkBilledDialog = ({
  show,
  onClose,
  markOrderAsBilled,
  title = 'Mark Order as Billed?',
  description = 'Are you sure you want to mark this report as billed?',
  successLabel = 'Order marked as billed.',
}: IProps) => {
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')

  return (
    <Modal centered show={!!show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {description}
        <br />
        <br />
        <Input
          handleChange={(e: SyntheticEvent) => setReason(e.target.value)}
          name="reason"
          label="Reason (optional)"
          value={reason}
          className="form-control w-100"
        />
        {error && <div className="text-danger">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          autoFocus
          variant="primary"
          onClick={async () => {
            setError('')
            try {
              await markOrderAsBilled(reason)
              onClose()
              setReason('')
              Toast({ type: 'success', label: successLabel })
            } catch (e) {
              if (e.data?.message?.statusCode === 404) return setError('Order not found')
              setError(e.data.message)
            }
          }}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
